(function () {
  'use strict';

  function getProductJson() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Failed to parse product JSON:', e);
      return null;
    }
  }

  function formatMoney(cents, shopMoneyFormat) {
    var amount = (cents / 100).toFixed(2);
    if (shopMoneyFormat) {
      return shopMoneyFormat.replace('{{amount}}', amount);
    }
    return '$' + amount;
  }

  function init() {
    var product = getProductJson();
    var optionsWrap = document.querySelector('.product-options');
    var hiddenInput = document.getElementById('ProductVariantId');
    if (!product || !hiddenInput) return;

    var priceEl = document.getElementById('ProductPrice');
    var addBtn = document.getElementById('ProductAddToCart');
    var selected = {};

    var current = product.variants.find(function (v) {
      return v.id === parseInt(hiddenInput.value, 10);
    });
    if (current) {
      selected[0] = current.option1;
      selected[1] = current.option2;
      selected[2] = current.option3;
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return (selected[0] === undefined || v.option1 === selected[0]) &&
               (selected[1] === undefined || v.option2 === selected[1]) &&
               (selected[2] === undefined || v.option3 === selected[2]);
      });
    }

    function updateSwatchUI() {
      if (!optionsWrap) return;
      optionsWrap.querySelectorAll('.swatch-btn').forEach(function (btn) {
        var idx = btn.dataset.optionIndex;
        btn.classList.toggle('is-selected', selected[idx] === btn.dataset.value);
      });
    }

    function applyVariant(variant) {
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      hiddenInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    if (optionsWrap) {
      optionsWrap.querySelectorAll('.swatch-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[this.dataset.optionIndex] = this.dataset.value;
          updateSwatchUI();
          applyVariant(findVariant());
        });
      });

      optionsWrap.querySelectorAll('.option-select').forEach(function (select) {
        select.addEventListener('change', function () {
          selected[this.dataset.optionIndex] = this.value;
          applyVariant(findVariant());
        });
      });
    }

    updateSwatchUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
